// extracted by mini-css-extract-plugin
export default {"loadingContainer":"playerResultsTab__loadingContainer__jOOMq","buttonContainer":"playerResultsTab__buttonContainer__bsryN"};